import React from 'react';
import { useTranslation } from 'react-i18next';
import { DrawSetting } from '@agissc/ktag-map';
import { Switch } from '@ktag/styleguide/dist/react';
import useAppState from '../../../AppStore';

const FilledOutSetting = () => {
  const { t } = useTranslation('agisviewer');

  const editDrawFeature = useAppState((state) => state.editDrawFeature);
  const setDrawSetting = useAppState((state) => state.setDrawSetting);

  const selectedFeatureId = useAppState((state) => state.selectedFeatureId);
  const drawFeatures = useAppState((state) => state.drawFeatures);
  const feature = drawFeatures.find(({ id }) => id === selectedFeatureId)!;

  const setChecked = (checked: boolean) => {
    editDrawFeature(feature.id as string, {
      properties: { settings: { [DrawSetting.FilledOut]: checked } },
    });
    setDrawSetting(DrawSetting.FilledOut, checked);
  };

  return (
    <Switch
      additionalClassNames="draw-settings__sliders"
      label={t('draw_tool_filled_out')}
      checked={feature.properties.settings[DrawSetting.FilledOut] ?? false}
      setChecked={setChecked}
    />
  );
};

export default FilledOutSetting;
